// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import "../Categorys/categorys.scss";
// import axios from "axios";
// import { AiFillEye } from "react-icons/ai";
// import { AiFillDelete } from "react-icons/ai";
// import { FiEdit } from "react-icons/fi";
// import { BsToggleOn, BsToggleOff } from "react-icons/bs";
// import { API_BASE_URL } from "../../../../utils/index";
// import Swal from "sweetalert2/dist/sweetalert2.js";
// import { useAuthHeaders } from "../../../../components/Token";
// import Lottie from "lottie-react";
// import Preloader from "../../../../Preloader/Preloader-Animation.json";



// function DescriptionVendorType() {
//   const [data, setData] = useState([]);
//   const headers = useAuthHeaders();
//   const [loading, setLoading] = useState(true);

//   const subdomain = localStorage.getItem("vendorsubdomain");


//   ;













//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         setLoading(true);
//         const response = await axios.get(`${API_BASE_URL}/description/admin/getdescriptions`);
//         setData(response.data?.description);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   const deleteCategory = (categoryId) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: "Are you sure you want to delete this Description Name?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, delete it!",
//     }).then((result) => {
//       if (result.isConfirmed) {
//         axios
//           .delete(
//             `${API_BASE_URL}/description/admin/deletedescription/${categoryId}`,
//             {
//               headers,
//             }
//           )
//           .then(() => {
//             setData((prevData) =>
//               prevData.filter((item) => item?._id !== categoryId)
//             );
//           })
//           .catch((error) => {
//             console.error("Error deleting category:", error);

//             Swal.fire({
//               icon: "error",
//               title: "Oops...",
//               text: error.response?.data.error,
//             });
//           });
//         Swal.fire({
//           title: "Deleted!",
//           text: "Your file has been deleted.",
//           icon: "success",
//         });
//       }
//     });
//   };

//   const toggleCategoryStatus = (categoryId, isActive) => {
//     axios
//       .put(
//         `${API_BASE_URL}/description/admin/statusdescription/${categoryId}`,
//         {
//           isActive: !isActive, // Toggle the active status
//         },
//         {
//           headers,
//         }
//       )
//       .then(() => {
//         // Update the local state to reflect the change
//         setData((prevData) =>
//           prevData.map((item) =>
//             item._id === categoryId ? { ...item, isActive: !isActive } : item
//           )
//         );
//       })
//       .catch((error) => {
//         console.error("Error toggling category status:", error);

//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: error.response?.data.error,
//         });
//       });
//   };

//   return (
//     <div className="p-4">
//       <div className="d-flex justify-content-between my-2">
//         <h2 className="m-0">Description Name</h2>
//         <Link to={`/${subdomain}/master/description-name/create`} className="btn btn-primary">
//           Add New
//         </Link>
//       </div>

//       <table className="categorys-table" style={{ boxShadow: "0 0 10px 0 rgba(0,0,0,0.45) inset" }}>
//         <thead>
//           <tr>
//             <th>Name</th>
//             <th>Sub Category</th>
//             <th>Category</th>
//             <th>Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {loading ? (
//             <Lottie
//               style={{ width: "100vw", height: "50vh" }}
//               animationData={Preloader}
//             />
//           ) : (<>
//             {data.map((item, index) => (
//               <tr key={index}>
//                 <td>{item?.descriptionName}</td>
//                 <td> {item?.subcategory?.name} </td>
//                 <td> {item?.category?.name} </td>
//                 <td>
//                   <Link to={`/descriptionTypeDetial/${item._id}`}>
//                     <button className="mx-1">
//                       <AiFillEye className="m-2 fs-6" />
//                     </button>
//                   </Link>
//                   <button
//                     className="mx-1"
//                     onClick={() => deleteCategory(item._id)}
//                   >
//                     <AiFillDelete className="m-2 fs-6" />
//                   </button>

//                   <Link to={`/editDescriptionType/${item._id}`}>
//                     <button className="mx-1">
//                       <FiEdit className="m-2 fs-6" />
//                     </button>
//                   </Link>

//                   <button
//                     className="mx-1"
//                     onClick={() => toggleCategoryStatus(item._id, item.isActive)}
//                   >
//                     {item.isActive ? (
//                       <BsToggleOn className="m-2 fs-6" />
//                     ) : (
//                       <BsToggleOff className="m-2 fs-6" />
//                     )}
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </>)}
//         </tbody>
//       </table>
//     </div>
//   );
// }

// export default DescriptionVendorType;


import React, { useContext, useEffect, useState } from "react";
import ToggleOffOutlinedIcon from '@mui/icons-material/ToggleOffOutlined';
import {
  Box,
  Typography,
  IconButton,
  Snackbar,
  Alert,
  Button,
  Tooltip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";

import { Link } from "react-router-dom";
import Lottie from "lottie-react";
import {
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  ToggleOn as ToggleOnIcon,
  ToggleOff as ToggleOffIcon,
} from "@mui/icons-material";

import Preloader from "../../../../Preloader/Preloader-Animation.json";
import { DELETEDESvendor, GetVendordescriptions, UpdatestatusVendorDES } from "../../../../services/api/Descriptions";
import userContext from "../../../../components/UseContext/UseContext";
import { BsToggleOff, BsToggleOn } from "react-icons/bs";


function DescriptionVendorType() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);
  const { permissionvalues } = useContext(userContext);
  const
    permissions = permissionvalues?.permissions?.master.description
  console.log(permissions, "permissions")

  const slugname = localStorage.getItem("vendorsubdomain");

  useEffect(() => {
    fetchData();
  }, [slugname]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await GetVendordescriptions(slugname);
      setData(response?.description || []);
    } catch (error) {
      setSnackbar({ open: true, message: "Failed to load data", severity: "error" });
    } finally {
      setLoading(false);
    }
  };

  const confirmDelete = (id) => {
    setSelectedDeleteId(id);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirmed = async () => {
    try {
      const response = await DELETEDESvendor(slugname, selectedDeleteId);
      console.log(response, "response,")
      if (response.success) {

        setData((prev) => prev.filter((item) => item._id !== selectedDeleteId));
        setSnackbar({ open: true, message: response.message, severity: "success" });
      } else {
        setSnackbar({ open: true, message: response.data.message, severity: "error" });

      }
    } catch (error) {
      setSnackbar({ open: true, message: "Failed to delete", severity: "error" });
    } finally {
      setDeleteDialogOpen(false);
      setSelectedDeleteId(null);
    }
  };

  const toggleStatus = async (id, isActive) => {
    try {
      await UpdatestatusVendorDES(slugname, { isActive: !isActive }, id);
      setData((prev) =>
        prev.map((item) =>
          item._id === id ? { ...item, isActive: !isActive } : item
        )
      );
      setSnackbar({
        open: true,
        message: `Status ${!isActive ? "Activated" : "Deactivated"}`,
        severity: "success",
      });
    } catch (error) {
      setSnackbar({ open: true, message: "Failed to update status", severity: "error" });
    }
  };

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Description Name</Typography>
        {permissions?.create &&

          <Button
            variant="contained"
            component={Link}
            to={`/${slugname}/master/description-name/create`}
          // sx={{ backgroundColor: "#0443c0", "&:hover": { backgroundColor: "#0333a0" } }}
          >
            Add New
          </Button>
        }
      </Box>
      {permissions?.read &&

        loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh" >
          <Lottie animationData={Preloader} style={{ width: 300 }} />
        </Box>
      ) : (
        <Paper sx={{ overflow: "auto" }}>
          <Table>
            <TableHead>
              <TableRow >
                <TableCell >Name</TableCell>
                <TableCell >Sub Category</TableCell>
                <TableCell >Category</TableCell>
                <TableCell >Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item, idx) => (
                <TableRow key={idx}>
                  {console.log(item, " {permissions.edit &&")}
                  <TableCell>{item?.descriptionName}</TableCell>
                  <TableCell>{item?.subcategory?.name}</TableCell>
                  <TableCell>{item?.category?.name}</TableCell>
                  <TableCell>
                    {/* {permissions?.read && item?.vendor &&
                      <Tooltip title="View">
                        <IconButton
                          color="primary"
                          component={Link}
                          to={`/descriptionTypeDetial/${item._id}`}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    } */}

                    {permissions?.edit && item?.vendor &&
                      <Tooltip title="Edit">
                        <IconButton
                          // color="secondary"
                          component={Link}
                          to={`/${slugname}/master/description-name/edit/${item._id}`}
                        >
                          <EditIcon fontSize="small" sx={{ color: "secondary" }} />
                        </IconButton>
                      </Tooltip>
                    }
                    {permissions?.delete && item?.vendor &&
                      <Tooltip title="Delete">
                        <IconButton color="error" onClick={() => confirmDelete(item._id)}>
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    }
                    {permissions?.edit && item?.vendor &&
                      <Tooltip title={item.isActive ? "Deactivate" : "Activate"}>
                        <IconButton onClick={() => toggleStatus(item._id, item.isActive)}>
                          {item.isActive ? (
                            <BsToggleOn color="green" />
                          ) : (
                             <BsToggleOff color="gray" />
                          )}
                        </IconButton>
                      </Tooltip>
                    }
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      )
      }

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete this description?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} color="inherit">
            Cancel
          </Button>
          <Button onClick={handleDeleteConfirmed} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar Notification */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          severity={snackbar.severity}
          variant="filled"
          onClose={() => setSnackbar({ ...snackbar, open: false })}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box >
  );
}

export default DescriptionVendorType;
